import {h} from "preact";
import Config from "../config";

import Header from "../desktop-components/site/header.jsx";
import Footer from "../desktop-components/site/footer.jsx";

import MenuPopup from "../desktop-components/user/menu-popup"
import SignupPopup from "../desktop-components/user/signup-popup"
import LoginPopup from "../desktop-components/user/login-popup";

export default function FullSite({children}) {
	return <div class="font-roboto">
		{!Config.hideHeader && <Header />}
		{children}
		{!Config.hideFooter && <Footer />}
		{!Config.hideHeader && <MenuPopup />}
		{!Config.hideHeader && <SignupPopup />}
		{!Config.hideHeader && <LoginPopup />}
	</div>
}
